import { Injectable } from "@angular/core";

@Injectable()
export class ConfigService
{
	public app: any;
	public appLayout: any;
	public breakpoint: any;

	constructor()
	{
		this.app =
		{
			name: "pCode"
		};

		this.appLayout =
		{
			isAppBoxed: false,
			isAppSidebarLeftCollapsed: false,
			isAppMobileSidebarLeftOpen: false,
			isAppSidebarRightOpen: false,
			isAppBackdropVisible: false
		};

		this.breakpoint =
		{
			desktopLG: 1280,
			desktop: 992,
			tablet: 768,
			mobile: 576
		};
	}
}
